import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import ProductCard from 'utils/product-card';
import AngleRightIcon from 'utils/icon/icon-angle-right.svg';
import getRecommendedProducts from 'utils/nosto-recommendations';

const Recommendations = ({ elements, ...props }) => {
  const placements = elements.map((el) => el.placementId);
  const isDesktop = props.layout.isAboveBreakpoint('lg');

  const [products, setProducts] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0); // Default to first tab
  const [recommendations, setRecommendations] = useState(null);

  useEffect(() => {
    if (props.useDomaineMarkup) {
      const loadRecommendations = async () => {
        try {
          const res = await getRecommendedProducts(placements);
          if (res) {
            setRecommendations(res.recommendations);
            setProducts(res.products);
          }
        } catch (error) {
          console.error('Error loading recommendations:', error);
        }
      };

      loadRecommendations();
    }
  }, [props.useDomaineMarkup]);

  return (
    <div>
      <div className="py-20">
        <div className="scrollbar-hide flex gap-20 overflow-x-auto overflow-y-hidden pl-15 l:max-w-[88%] l:gap-30 l:pl-40">
          {elements.map((el, index) => {
            const title = el.title || (recommendations && recommendations[el.placementId]?.title);
            return (
              <button
                key={el.placementId}
                className={`h3 whitespace-nowrap !leading-120 text-primary hover:underline ${
                  index !== activeIndex ? 'opacity-70' : ''
                } ${elements.length > 1 && index === activeIndex && 'underline underline-offset-2'}`}
                onClick={() => setActiveIndex(index)}
              >
                {title}
              </button>
            );
          })}
        </div>
        {elements.map((el, index) => {
          if (!props.useDomaineMarkup) {
            // Render empty divs with explicit IDs
            return (
              <div
                key={`placeholder-${index}`}
                className={`relative ${index === activeIndex ? '' : 'hidden'}`}
              >
                <div id={el.placementId}></div>
              </div>
            );
          }

          const productList = products ? products[el.placementId] : [];
          return (
            <div
              className={`nosto_element nosto-dynamic-placement ${index === activeIndex ? '' : 'hidden'}`}
              key={`rec-${index}`}
            >
              {isDesktop && productList.length > 5 && (
                <div className="absolute -top-[60px] right-40 flex gap-6">
                  <button
                    data-arrow-left={`${index}`}
                    className="arrow-circle swiper-button-disabled rotate-180 disabled:border-disabled disabled:text-disabled"
                  >
                    <span className="sr-only">{window.TMW.Strings.accessibility.prevProduct}</span>
                    <AngleRightIcon />
                  </button>
                  <button
                    data-arrow-right={`${index}`}
                    className="arrow-circle swiper-button-disabled disabled:border-disabled disabled:text-disabled"
                  >
                    <span className="sr-only">{window.TMW.Strings.accessibility.nextProduct}</span>
                    <AngleRightIcon />
                  </button>
                </div>
              )}
              <Swiper
                modules={[Navigation]}
                slidesPerView={1.5}
                spaceBetween={isDesktop ? 16 : 12}
                navigation={{
                  nextEl: `[data-arrow-right="${index}"]`,
                  prevEl: `[data-arrow-left="${index}"]`,
                }}
                slidesOffsetBefore={15}
                breakpoints={{
                  1024: {
                    slidesPerView: 5.6,
                    spaceBetween: 12,
                    slidesOffsetBefore: 40,
                  },
                  768: {
                    slidesPerView: 3.5,
                  },
                }}
              >
                {productList.map((product) => (
                  <SwiperSlide
                    key={product.id}
                    className="!flex min-h-24 items-center justify-center"
                  >
                    <ProductCard
                      key={product.id}
                      product={product}
                      template={`reco-${index}`}
                      {...props}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Recommendations;
